import {
  ContractorReviewDetailDto,
  ContractorReviewSummaryDto
} from './../../models/contractor/contractor-review/contractor-review-summary.dto';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CreateContractorReviewDto } from './../../models/contractor/contractor-review/create-contractor-review.dto';
import { UpdateContractorReviewDto } from './../../models/contractor/contractor-review/update-contractor-review.dto';
import {
  FacilityReviewDetailDto,
  FacilityReviewParams
} from './../../models/contractor/contractor-review/facility-review-detail.dto';
import { HttpHelper, ScopeOfPracticeEnum } from '@umss/shared/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContractorReviewService {
  private readonly apiUrl = '/api/facilities';
  private readonly http = inject(HttpClient);

  get(
    facilityId: string,
    contractorId: string,
    scope: ScopeOfPracticeEnum
  ): Observable<ContractorReviewDetailDto> {
    return this.http.get<ContractorReviewDetailDto>(
      `${this.apiUrl}/${facilityId}/contractors/${contractorId}/reviews/${scope}`
    );
  }

  getReviews(
    contractorId: string,
    payload: FacilityReviewParams
  ): Observable<FacilityReviewDetailDto[]> {
    const params = HttpHelper.toHttpParams(payload);
    return this.http.get<FacilityReviewDetailDto[]>(
      `api/contractors/${contractorId}/reviews`,
      { params }
    );
  }

  create(
    facilityId: string,
    contractorId: string,
    requestBody: CreateContractorReviewDto
  ): Observable<ContractorReviewSummaryDto> {
    return this.http.post<ContractorReviewSummaryDto>(
      `${this.apiUrl}/${facilityId}/contractors/${contractorId}/reviews`,
      requestBody
    );
  }

  update(
    facilityId: string,
    contractorId: string,
    scope: ScopeOfPracticeEnum,
    requestBody: UpdateContractorReviewDto
  ): Observable<ContractorReviewSummaryDto> {
    return this.http.put<ContractorReviewSummaryDto>(
      `${this.apiUrl}/${facilityId}/contractors/${contractorId}/reviews/${scope}`,
      requestBody
    );
  }
}
